<template>
  <div
    class="relative w-full flex items-center justify-between h-[100px] pl-5 pr-10  mobile:h-[70px] tablet:h-[100px] rounded-lg justify-start">
    <img src="../../assets/images/profile-bg.png" class="w-full object-cover absolute left-0 top-0"
      alt="backgroundImage">
    <div class="flex justify-between items-center w-full">
      <div class="flex items-center justify-start mobile:gap-2 tablet:gap-3 z-50 relative mobile:top-8 tablet:top-12">
        <div
          class="rounded-full p-2 overflow-hidden mobile:w-20 mobile:h-20 tablet:w-28 tablet:h-28 largeDesktop:w-32 largeDesktop:h-32 shadow-[0px_4px_10px_0px_#00000040;] bg-white">
          <img :src="imageSrc" alt="Profile Picture" class="object-cover object-top w-full h-full rounded-full" />
        </div>
        <div v-if="showEditForm && !showChangePasswordForm" class="">
          <img src="../../assets/images/camera-icon.png" @click="triggerFileUpload"
            class="mobile:w-8 mobile:h-8 tablet:w-10 tablet:h-10 cursor-pointer" alt="icon">
          <input type="file" accept="image/*" ref="fileInput" @change="handleFileChange" class="hidden" />
        </div>
      </div>
      <!-- Buttons -->
      <div class="flex gap-3 mr-4 z-50">
        <button v-if="!showEditForm && !showChangePasswordForm" @click="openEditForm"
          class="mobile:text-sm tablet:text-base largeDesktop:text-lg rounded-full mobile:px-2.5 mobile:py-1 tablet:px-4 tablet:py-1 largeDesktop:px-4 largeDesktop:py-1.5 bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040] cursor-pointer">
          Edit Profile
        </button>

        <button v-if="false && showEditForm && !showChangePasswordForm" @click="openChangePasswordForm"
          class="mobile:text-sm tablet:text-base largeDesktop:text-lg rounded-full mobile:px-2.5 mobile:py-1 tablet:px-4 tablet:py-1 largeDesktop:px-4 largeDesktop:py-1.5 bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040] cursor-pointer">
          Change Password
        </button>
      </div>
    </div>
  </div>
  <div v-if="!showEditForm && !showChangePasswordForm && user">
    <div class="flex justify-end mt-3 mobile:mb-6 tablet:mb-12">
      <ul class="list-inline mb-0 p-0 flex items-center">
        <li class="px-2 " :class="lang && lang.length > 1 ? 'border-r-2 border-[#7695FF]' : ''"
          v-for="(lang, index) in user.user.languages" :key="index">
          <a class="mobile:text-sm tablet:text-base text-right no-underline text-gray-500">{{ lang.name
          }}</a>
        </li>
      </ul>
    </div>
    <div class="w-full flex flex-col mobile:px-2 tablet:px-4 gap-2">
      <div>
        <h4 class="m-0 mobile:text-xl tablet:text-xl largeDesktop:text-2xl font-bold text-gray-900">Hi, {{
          user.user.full_name }}</h4>
        <p class="m-0 mobile:text-base tablet:text-base largeDesktop:text-lg text-gray-500 ">{{ user.user.email }}</p>
      </div>
      <div>
        <span class="mobile:text-base tablet:text-base largeDesktop:text-lg text-[#BA90C6]">Company</span>
        <p class="m-0 mobile:text-base tablet:text-base largeDesktop:text-lg text-gray-900">{{ user.user.company }}</p>
      </div>
      <div>
        <span class="mobile:text-base tablet:text-base largeDesktop:text-lg text-[#BA90C6]">Company Address</span>
        <p class="m-0 mobile:text-base tablet:text-base largeDesktop:text-lg text-gray-900">{{
          user.user.company_address?.address_1 ?? '-' }}
        </p>
      </div>
    </div>
    <div class="mobile:px-2 tablet:px-4">
      <span class="mobile:text-base tablet:text-base largeDesktop:text-lg text-[#BA90C6] mb-1 inline-block">Area of
        Expertise</span>
      <ul class="list-inline mb-0 flex flex-wrap mobile:max-h-40 laptop:max-h-72 overflow-y-auto customScrollbar">
        <li class="m-1" v-for="(expert, index) in user.user.expertises" :key="index">
          <span
            class="mobile:py-1 mobile:px-3 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-sm tablet:text-base inline-block bg-gray-200">{{
              expert.title }}</span>
        </li>
      </ul>
    </div>
    <button @click="signoutClicked" type="button"
      class="mobile:py-1.5 mobile:px-5 tablet:py-1.5 tablet:px-4 largeDesktop:py-2 largeDesktop:px-4 mt-4 mobile:mx-2 tablet:mx-4 mobile:text-base tablet:text-base largeDesktop:text-lg  rounded-full no-underline w-max text-white bg-[#987D9A] hidden laptop:block">Sign
      Out</button>
  </div>

  <!-- Edit Profile Form -->
  <div v-if="showEditForm && !showChangePasswordForm">
    <form action="#"
      class="mobile:mt-12 tablet:mt-20">
      <div class="w-full flex flex-col gap-2 mobile:px-2 tablet:px-4 max-h-[300px] tablet:max-h-[none] overflow-y-auto customScrollbar">
        <div class="pt-1">
          <inputComponent ref="firstNameRef" v-model="first_name" name="firstName" required
            placeholder="Enter First Name" />
        </div>
        <div class="pt-1">
          <inputComponent ref="lastNameRef" v-model="last_name" name="lastName" required
            placeholder="Enter Last Name" />
        </div>
        <div class="pt-1">
          <inputComponent ref="emailRef" v-model="email" name="email" :regex="$constants.EMAIL_REGEX" disabled
            error-message="Please enter a valid email address" placeholder="Enter Email" />
        </div>
        <div class="pt-1 flex gap-2">
          <div class="w-1/2">
            <inputComponent ref="yearsofexperienceRef" type="number" v-model="years_of_experience"
              name="yearsofexperience" required placeholder="Enter Years Of Experience" class="" />
          </div>
          <div class="w-1/2">
            <inputComponent ref="phoneRef" v-model="phone" name="phone" required mask="(###) ###-####"
              placeholder="Enter Number" error-message="Invalid phone number" />
          </div>
        </div>
        <div class="pt-2">
          <h4 class="text-lg font-medium">Select Language (Optional)</h4>
          <div class="flex flex-wrap gap-2 pt-2">
            <span v-for="lan in language" :key="lan" @click="toggleLang(lan)" :class="[
              'mobile:py-1 mobile:px-2.5 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-sm tablet:text-base cursor-pointer transition',
              selectedLanguage.includes(lan.id) ? 'bg-[#7695FF] text-white' : 'bg-gray-200 text-black'
            ]">
              {{ lan.name }}
            </span>
          </div>
          <h4 class="text-lg font-medium mt-3">Area of Expertise:</h4>
          <div class="flex flex-wrap gap-2 pt-2">
            <span v-for="tag in tags" :key="tag" @click="toggleTag(tag)" :class="[
              'mobile:py-1 mobile:px-2.5 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-sm tablet:text-base cursor-pointer transition',
              selectedTags.includes(tag.id) ? 'bg-[#BA90C6] text-white' : 'bg-gray-200 text-black'
            ]">
              {{ tag.title }}
            </span>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-center gap-3 pt-4 mt-4 border-t border-gray-200">
        <button type="button" @click="backUserClicked"
          class="mobile:py-1.5 mobile:px-5 tablet:py-2 tablet:px-4 mobile:text-sm tablet:text-base rounded-lg bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040]">Back</button>
        <button type="button" @click="updateUserClicked"
          class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-4 mobile:text-sm tablet:text-base rounded-lg bg-[#00B7C2] text-white hover:shadow-[0px_4px_10px_0px_#00000040]">Save
          Changes</button>
      </div>
    </form>
  </div>

  <!-- Change Password Form -->
  <div v-if="showChangePasswordForm">
    <form action="#" class="mobile:mt-12 tablet:mt-20 mobile:px-2 tablet:px-4">
      <div class="w-full flex flex-col gap-2">
        <div class="pt-1">
          <label for="currentPassword" class="text-sm text-gray-400">Current Password</label>
          <div class="relative">
            <input :type="showCurrentPassword ? 'text' : 'password'" v-model="currentPassword"
              placeholder="Current Password" id="currentPassword"
              class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm" />
            <span class="flex justify-center items-center absolute right-0 top-0 h-full w-9"
              @click="showCurrentPassword = !showCurrentPassword">
              <img :src="showCurrentPassword ? showEyeIcon : hideEyeIcon" alt="Toggle visibility"
                class="w-6 h-6 cursor-pointer" />
            </span>
          </div>
        </div>
        <div class="pt-1">
          <label for="newPassword" class="text-sm text-gray-400">New Password</label>
          <div class="relative">
            <input :type="showNewPassword ? 'text' : 'password'" v-model="newPassword" placeholder="New Password"
              id="newPassword"
              class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm" />
            <span class="flex justify-center items-center absolute right-0 top-0 h-full w-9"
              @click="showNewPassword = !showNewPassword">
              <img :src="showNewPassword ? showEyeIcon : hideEyeIcon" alt="Toggle visibility"
                class="w-6 h-6 cursor-pointer" />
            </span>
          </div>
        </div>
        <div class="pt-1">
          <label for="confirmPassword" class="text-sm text-gray-400">Confirm Password</label>
          <div class="relative">
            <input :type="showConfirmPassword ? 'text' : 'password'" v-model="confirmPassword"
              placeholder="Confirm Password" id="confirmPassword"
              class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm" />
            <span class="flex justify-center items-center absolute right-0 top-0 h-full w-9"
              @click="showConfirmPassword = !showConfirmPassword">
              <img :src="showConfirmPassword ? showEyeIcon : hideEyeIcon" alt="Toggle visibility"
                class="w-6 h-6 cursor-pointer" />
            </span>
          </div>
        </div>
        <p class="mb-0 mt-3 text-[#674188]">Minimum number of character 5</p>
        <div class="flex items-center justify-center gap-3 pt-4 mt-4 border-t border-gray-200">
          <button type="button"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-4 mobile:text-sm tablet:text-base rounded-lg bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040]">Cancel</button>
          <button type="button"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-4 mobile:text-sm tablet:text-base rounded-lg bg-[#00B7C2] text-white hover:shadow-[0px_4px_10px_0px_#00000040]">Save
            Changes</button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
import { ref } from 'vue'
import showEyeIcon from '../../assets/images/eyeshowIcon.png';
import hideEyeIcon from '../../assets/images/eyehideIcon.png';
import { mapActions, mapGetters } from "vuex";
import inputComponent from '../../components/partialComponent/inputComponent.vue'
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  components: {
    inputComponent
  },
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    openModal: {

    },
    bootme: {

    },
    clickedCallback: {

    },
    userObject: {

    }
  },

  data() {
    return {
      // Visibility flags
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,

      // Input values

      email: null,
      phone: null,
      first_name: null,
      last_name: null,
      years_of_experience: null,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',

      // Icons
      showEyeIcon,
      hideEyeIcon,
      imageSrc: 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg',
      imageFile: null,
      tags: [],
      language: [],
      selectedTags: [],
      selectedLanguage: [],
      showEditForm: false,
      showChangePasswordForm: false,
      user: JSON.parse(localStorage.getItem('user')) ?? null
    };
  },

  computed: {
    ...mapGetters(["updatedUser"]),
  },

  watch: {
    updatedUser: function () {
      toast.success("Profile has been updated successfully.")
      this.showEditForm = false
      this.user.user = this.updatedUser
      localStorage.setItem('user', JSON.stringify(this.user))
    },

    openModal: function () {
      this.showCurrentPassword = false
      this.showNewPassword = false
      this.showConfirmPassword = false
      this.showEditForm = false
      this.showChangePasswordForm = false
      this.imageFile = null
      this.setUser()
    },
    bootme: function () {
      this.language = this.bootme.languages
      this.tags = this.bootme.expertise
    },

  },

  methods: {
    ...mapActions(["updateUser"]),

    submitClicked() {

      const refsToValidate = [
        this.$refs.firstNameRef,
        this.$refs.lastNameRef,
        this.$refs.emailRef,
        this.$refs.phoneRef,
        this.$refs.yearsofexperienceRef
      ];

      let firstInvalidRef = null;

      // Validate each ref
      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }
      this.updateCall()
    },

    updateUserClicked() {
      this.submitClicked()

    },
    updateCall() {
      let formData = new FormData()
      formData.append("first_name", this.first_name)
      formData.append("last_name", this.last_name)
      formData.append("phone", this.phone)
      formData.append("email", this.email)
      formData.append("years_of_experience", this.years_of_experience)
      formData.append("languages", JSON.stringify(this.selectedLanguage))
      formData.append("expertise", JSON.stringify(this.selectedTags))
      formData.append("timestamp", (new Date()).getTime())


      if (this.imageFile) {
        formData.append("profile_picture", this.imageFile)
      }

      this.updateUser(formData)
    },
    backUserClicked() {
      this.showEditForm = false
    },
    setUser() {
      this.user = this.userObject

      this.email = this.user.user.email ?? null
      this.phone = this.user.user.phone ?? null
      this.first_name = this.user.user.first_name ?? null
      this.last_name = this.user.user.last_name ?? null
      this.years_of_experience = this.user.user.years_of_experience ?? null
      this.imageSrc = this.user.user.profile_picture ?? 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg'

      this.selectedTags = (this.user.user.expertises ?? []).map(item => item.id);
      this.selectedLanguage = (this.user.user.languages ?? []).map(item => item.id);
    },
    signoutClicked() {
      if (this.clickedCallback) {
        this.clickedCallback('signout')
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      this.imageFile = event.target.files[0]
      if (this.imageFile) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imageSrc = e.target.result
        }
        reader.readAsDataURL(this.imageFile)
      }
    },
    toggleTag(tag) {
      if (this.selectedTags.includes(tag.id)) {
        this.selectedTags = this.selectedTags.filter(t => t !== tag.id)
      } else {
        this.selectedTags.push(tag.id)
      }
    },
    toggleLang(lang) {
      if (this.selectedLanguage.includes(lang.id)) {
        this.selectedLanguage = this.selectedLanguage.filter(t => t !== lang.id)
      } else {
        this.selectedLanguage.push(lang.id)
      }
    },
    openEditForm() {
      this.showEditForm = true
    },
    openChangePasswordForm() {
      this.showEditForm = false
      this.showChangePasswordForm = true
    }
  },

};
</script>
